import { useEffect } from "react";

/**
 * Lightweight per-route SEO manager. Google fully renders JavaScript so
 * updating document.title + meta tags on navigation is sufficient for
 * indexing individual routes without a helmet lib.
 */
export default function SEO({
  title,
  description,
  canonical,
  image,
  type = "website",
}) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    const setLink = (rel, href) => {
      if (!href) return;
      let el = document.head.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);
    if (canonical) {
      setLink("canonical", canonical);
      setMeta("property", "og:url", canonical);
    }
  }, [title, description, canonical, image, type]);

  return null;
}
